import {alert} from "../../../../../public/hatchly-core/js/core/vendor.javascript";

class Register {

    constructor() {
        window, Nav.navOpacityChanger();

        $(window).scroll(() => {
            return this.windowScrollEventHandler();
        });

        const staffType = $('#staff-type');
        const subtype = $('#subtype');

        this.staffTypeChangeEventHandler(staffType.val());
        this.subtypeChangeEventHandler(staffType.val(), subtype.val());

        staffType.change(() => {
            return this.staffTypeChangeEventHandler(staffType.val());
        });

        subtype.change(() => {
            this.subtypeChangeEventHandler(staffType.val(), subtype.val());
        });
    }

    windowScrollEventHandler() {
        const $header = $('section.header');
        const offset = $(window).scrollTop() * 0.25;
        return $header.css({
            'background-position': `50% ${ offset }px`,
        });
    }

    staffTypeChangeEventHandler(value) {
        const submitButton = $('#personal-details-submit');
        const checkBoxText = $('#checkbox-text');
        const completeRegText = 'Complete Registration <i class="fa fa-check"></i>';
        const defaultText = 'I am registered as a GMC doctor';

        const title = $("#title");
        const titles = ['mr', 'mrs', 'ms', 'miss'];
        const titlesGp = ['dr', 'prof'];

        title.empty();
        titles.forEach((value) => {
            title.append($("<option></option>")
                .attr("value", value).text(value.charAt(0).toUpperCase() + value.slice(1)));
        });

        this.toggleProfessionSubtypeField(value)

        switch (value) {
            case '1':
                checkBoxText.html(defaultText);
                submitButton.html('Proceed to pension details <i class="fa fa-chevron-right"></i>');
                this.updateProfessionNumberText('GMC');

                titlesGp.forEach((value) => {
                    title.append($("<option></option>")
                        .attr("value", value).text(value.charAt(0).toUpperCase() + value.slice(1)));
                });
                break;
            case '2':
                checkBoxText.html('I am a NMC registered nurse');
                submitButton.html(completeRegText);
                this.updateProfessionNumberText('NMC');
                break;
            case '3':
                checkBoxText.html('I am a qualified HCA');
                submitButton.html(completeRegText);
                this.toggleProfessionNumberField(false);
                break;
            case '4':
                checkBoxText.html('I am an experienced primary care administrator');
                submitButton.html(completeRegText);
                this.toggleProfessionNumberField(false);
                break;
            case '5':
                checkBoxText.html('I am a registered clinical pharmacist');
                submitButton.html(completeRegText);
                this.updateProfessionNumberText('GPhC');
                break;
            case '6':
                checkBoxText.html('I am a registered paramedic');
                submitButton.html(completeRegText);
                this.updateProfessionNumberText('HCPC');
                break;
            case '7':
                checkBoxText.html('I am a registered physiotherapist');
                submitButton.html(completeRegText);
                this.updateProfessionNumberText('HCPC');
                break;
            case '8':
                checkBoxText.html('I am a qualified social prescribing link worker');
                submitButton.html(completeRegText);
                this.toggleProfessionNumberField(false);
                break;
            case '9':
                checkBoxText.html('I am a qualified mental health worker');
                submitButton.html(completeRegText);
                this.toggleProfessionNumberField(false);
                break;
            case '10':
                checkBoxText.html('I am a qualified physician associate');
                submitButton.html(completeRegText);
                this.toggleProfessionNumberField(false);
                break;
            case '11':
                checkBoxText.html('I am an NMC registered nursing associate');
                submitButton.html(completeRegText);
                this.toggleProfessionNumberField('NMC');
                break;
            case '12':
                checkBoxText.html('I am a GPhC registered pharmacy technician');
                submitButton.html(completeRegText);
                this.toggleProfessionNumberField('GPhC');
                break;
            case '13':
                checkBoxText.html('I am a qualified health and wellbeing coach');
                submitButton.html(completeRegText);
                this.toggleProfessionNumberField(false);
                break;
            case '14':
                checkBoxText.html('I am a qualified care coordinator');
                submitButton.html(completeRegText);
                this.toggleProfessionNumberField(false);
                break;
            case '15':
                checkBoxText.html('I am an HCPC registered dietician');
                submitButton.html(completeRegText);
                this.toggleProfessionNumberField('HCPC');
                break;
            case '16':
                checkBoxText.html('I am an HCPC registered podiatrist');
                submitButton.html(completeRegText);
                this.toggleProfessionNumberField('HCPC');
                break;
            case '17':
                checkBoxText.html('I am an HCPC registered occupational therapist');
                submitButton.html(completeRegText);
                this.toggleProfessionNumberField('HCPC');
                break;
            case '18':
                checkBoxText.html('I am a qualified advanced practitioner');
                submitButton.html(completeRegText);
                this.toggleProfessionNumberField(false);
                break;
            default:
                checkBoxText.html(defaultText);
                submitButton.html(completeRegText);
                break;
        }
    }

    subtypeChangeEventHandler(staffType, subtype) {
        if (staffType !== '11') {
            return;
        }

        if (subtype === '0') {
            $('#checkbox-text').html('I am an NMC registered nursing associate');
            this.toggleProfessionNumberField(true);
        } else if (subtype === '1') {
            $('#checkbox-text').html('I am a trainee nursing associate');
            this.toggleProfessionNumberField(false);
        }
    }

    toggleProfessionNumberField(display) {
        const fieldParent = $("input[name='profession_number']").parent();
        const phoneNumberParent = $("input[name='phone_number']").parent();

        if (display) {
            phoneNumberParent.removeClass('full-input').addClass('half-input');
            fieldParent.show();
        } else {
            phoneNumberParent.removeClass('half-input').addClass('full-input');
            fieldParent.hide();
        }
    }

    updateProfessionNumberText(text) {
        this.toggleProfessionNumberField(true);

        $("input[name='profession_number']").attr('placeholder', text + ' number');
    }

    toggleProfessionSubtypeField(typeId) {
        if (typeId === '') return;

        // See \Locum\Models\Profession::SUBTYPES
        const subtypes = {
            1: {
                0: 'Partner',
                1: 'Salaried',
                2: 'Locum',
                3: 'Emergency Returner'
            },
            11: {
                0: 'Nursing Associate',
                1: 'Trainee Nursing Associate'
            }
        };
        const subTypeElem = $("#subtype");
        const oldSubType = $('#oldSubtype').data('old-subtype');

        if (typeId in subtypes) {
            subTypeElem.empty();
            subTypeElem.append($("<option>How would you describe your main role?</option>"))

            for (const [key, value] of Object.entries(subtypes[typeId])) {
                let option = $("<option></option>");
                option.attr("value", key).text(value);

                if (oldSubType !== undefined && oldSubType === parseInt(key)) {
                    option.attr('selected', true);
                }

                subTypeElem.append(option);
            }

            subTypeElem.parent().parent().show();
        } else {
            subTypeElem.parent().parent().hide();
        }
    }
}

export default Register;
